import { render } from "./OrderNotes.vue?vue&type=template&id=60c5ab88"
import script from "./OrderNotes.vue?vue&type=script&lang=js"
export * from "./OrderNotes.vue?vue&type=script&lang=js"

import "./OrderNotes.vue?vue&type=style&index=0&id=60c5ab88&scope=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022759/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__